export default {
    state: {
        accountPermissionGroupList: [],
        accountPermissionGroupListLoaded: [],
        accountPermissionGroupListLoader: false,
        accountPermissionGroupColumn: [],
        accountPermissionGroupListLoading: false,
    },
    actions: {
        async fetchAccountPermissionGroupList(ctx) {
            ctx.commit('updateAccountPermissionGroupListLoading', true)
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/account/?order_by=username", requestParams);

            if (!res.ok) {
                console.log('Error fetchItemList:', res)
                ctx.commit('updateLoading', false)
                this._vm.$toast.error("Error:" + res.statusText + ', ' + res.status, {timeout: 5000})
                const result = await res.json()
                console.log('Error fetchItemList:', result)
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                return
            }
            const resJson = await res.json();
            // const totalRecords = resJson.count
            const accountList = resJson.results


            const permissionGroupList = ctx.getters.getAccountPermissionGroupPermissionColumn
            for (let account of accountList) {
                for (let permissionGroup of permissionGroupList) {
                    account[permissionGroup.value] = account.groups.includes(permissionGroup.value);
                }
            }
            ctx.commit('updateAccountPermissionGroupList', accountList)
            ctx.commit('updateAccountPermissionGroupListLoading', false)
            // console.log('accountList')
            // console.log(accountList)
        },
        async fetchAccountPermissionGroupColumn(ctx) {
            ctx.commit('updateAccountPermissionGroupListLoading', true)
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/account_permission_group/", requestParams);
            if (!res.ok) {
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                ctx.commit('updateAccountPermissionGroupListLoading', false)
                return
            }
            const accountPermissionGroupList = await res.json();
            ctx.commit('updateAccountPermissionGroupColumn', accountPermissionGroupList)
            ctx.commit('updateAccountPermissionGroupListLoading', false)
            // console.log('accountPermissionGroupList')
            // console.log(accountPermissionGroupList)
        },
        async saveAccountPermissionGroupList(ctx) {
            ctx.commit('updateAccountPermissionGroupListLoading', true)
            let csrfToken = this._vm.$readCookie('csrftoken')
            let accountPermissionGroupListLoaded = ListToSet(ctx.state.accountPermissionGroupListLoaded)
            for (let accountPermissionGroup of ctx.state.accountPermissionGroupList) {
                let accountPermissionGroupStringify = JSON.stringify(accountPermissionGroup)
                if (!accountPermissionGroupListLoaded.has(accountPermissionGroupStringify)) {
                    let groups = []
                    for (let accountPermissionGroupHeader of ctx.state.accountPermissionGroupColumn) {
                        if (accountPermissionGroup[accountPermissionGroupHeader.id])
                            groups.push(accountPermissionGroupHeader.id)
                    }
                    const requestParams = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'groups': groups,
                        })
                    };
                    const res = await fetch("/api/account/" + accountPermissionGroup.id + '/',
                        requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateAccountPermissionGroupListLoading', false)
                    }
                }
            }
            ctx.commit('updateAccountPermissionGroupList', ctx.state.accountPermissionGroupList)
            ctx.commit('updateAccountPermissionGroupListLoading', false)
        },
    },
    mutations: {
        updateAccountPermissionGroupList(state, accountPermissionGroupList) {
            state.accountPermissionGroupList = accountPermissionGroupList
            state.accountPermissionGroupListLoaded = JSON.parse(JSON.stringify(accountPermissionGroupList))
        },
        updateAccountPermissionGroupColumn(state, accountPermissionGroupColumn) {
            state.accountPermissionGroupColumn = accountPermissionGroupColumn

        },
        updateAccountPermissionGroupListLoading(state, accountPermissionGroupListLoading) {
            state.accountPermissionGroupListLoading = accountPermissionGroupListLoading
        },
    },
    getters: {
        getAccountPermissionGroupList(state) {
            return state.accountPermissionGroupList
        },
        getAccountPermissionGroupColumn(state, getters) {
            let accountPermissionGroupColumn = [
                //'username', 'first_name', 'last_name', 'email', 'is_active', 'last_login', 'notion_id', 'groups'
                // {text: 'ID', value: 'id', sortable: true, filterable: false},
                {text: 'User name', value: 'username', sortable: true, filterable: false, divider: true},
                {text: 'First name', value: 'first_name', sortable: true, filterable: false, divider: true},
                {text: 'Last name', value: 'last_name', sortable: true, filterable: false, divider: true},
                {text: 'Email', value: 'email', sortable: true, filterable: false, divider: true},
                {text: 'Last logon', value: 'last_login', sortable: true, filterable: false, divider: true},
                {text: 'Notion ID', value: 'notion_id', sortable: false, filterable: false, divider: true},
                // {text: 'Groups', value: 'groups', sortable: false, filterable: false},
            ]
            for (const permissionGroup of state.accountPermissionGroupColumn) {
                accountPermissionGroupColumn.push(
                    {
                        text: permissionGroup.name, value: permissionGroup.id,
                        sortable: false, filterable: false, cellClass: 'permission'
                    }
                )
            }
            // console.log('accountPermissionGroupColumn')
            // console.log(accountPermissionGroupColumn)
            return accountPermissionGroupColumn
        },
        getAccountPermissionGroupPermissionColumn(state) {
            let accountPermissionGroupColumn = []
            for (const permissionGroup of state.accountPermissionGroupColumn) {
                accountPermissionGroupColumn.push(
                    {
                        text: permissionGroup.name, value: permissionGroup.id,
                        sortable: false, filterable: false, cellClass: 'permission'
                    }
                )
            }
            // console.log('accountPermissionGroupColumn')
            // console.log(accountPermissionGroupColumn)
            return accountPermissionGroupColumn
        },
        getAccountPermissionGroupListLoading(state) {
            return state.accountPermissionGroupListLoading
        },
    }
}

function ListToSet(sourceList) {
    let result = new Set()
    for (const source of sourceList) {
        result.add(JSON.stringify(source))
    }
    return result
}